import React from 'react';
import { ContactSection } from '../elements/contact-section';
import NpiMarketingBanner from '../elements/npi-level-marketing/main-banner';
import { Advantages } from '../elements/npi-level-marketing/advantages';
import npiBannerImg from '../../images/npi-hero-img.png';
import { DigitalSection } from '../elements/npi-level-marketing/digital-section';
import { MetricsSection } from '../elements/npi-level-marketing/metrics-section';
import { PilotSection } from '../elements/npi-level-marketing/pilot-section';
import { NpiTargeting } from '../elements/npi-level-marketing/npi-targeting';
import { StoryTelling } from '../elements/npi-level-marketing/story-telling';
import { VideoPortfolio } from '../elements/npi-level-marketing/video-portfolio';
import { CandidateStrategy } from '../elements/npi-level-marketing/candidate-strategy';

function NpiLevel() {
  return (
    <>
      <NpiMarketingBanner
        title="A Smarter, More Scalable Approach"
        topic="Using NPI-Level Data to Reach Passive HCPs Online"
        description="To help engage HCPs, you now have a powerful and precise way to reach your target audience by utilizing specific clinical codes like NPI numbers, ICD-10, or CPT codes. <br/> We collaborate with clients strategically to define KPIs, drive new HCP acquisitions, expand engagement with current providers, and cross-sell relevant solutions—ultimately increasing HCP adoption rates with measurable results."
        image={npiBannerImg}
      />
      <Advantages />
      <DigitalSection />
      <MetricsSection />
      <PilotSection />
      <NpiTargeting />
      <StoryTelling />
      <VideoPortfolio />
      <CandidateStrategy />
      <ContactSection />
    </>
  );
}

export default NpiLevel;
